import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowLeftFromSquare = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M6.17416 4V5.5C6.17416 5.9125 6.48394 6.25 6.86255 6.25C7.24117 6.25 7.55094 5.9125 7.55094 5.5V4H15.1232V13H7.55094V11.5C7.55094 11.0875 7.24117 10.75 6.86255 10.75C6.48394 10.75 6.17416 11.0875 6.17416 11.5V13C6.17416 13.825 6.79371 14.5 7.55094 14.5H15.1232C15.8804 14.5 16.5 13.825 16.5 13V4C16.5 3.175 15.8804 2.5 15.1232 2.5H7.55094C6.79371 2.5 6.17416 3.175 6.17416 4Z",
		fill: "#3C59F6"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M11.6813 8.5C11.6813 8.0875 11.3715 7.75 10.9929 7.75L4.10899 7.75V6.4075C4.10899 6.07 3.73726 5.905 3.52386 6.145L1.60326 8.2375C1.46558 8.3875 1.46558 8.62 1.60326 8.77L3.52386 10.8625C3.73726 11.095 4.10899 10.93 4.10899 10.5925V9.25H10.9929C11.3715 9.25 11.6813 8.9125 11.6813 8.5Z",
		fill: "#3C59F6"
	})]
});
export default SvgArrowLeftFromSquare;
